import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../components/AuthProvider'

/**
 * If the user already has a session, send them into the authenticated app.
 * Use on public/marketing pages. Skip on password-recovery flows that need the session.
 */
export function useRedirectIfAuthenticated({ to = '/app' } = {}) {
  const { user, loading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (loading || !user) return
    navigate(to, { replace: true })
  }, [loading, user, to, navigate])
}
